export default "__VITE_ASSET__DE1zFZo2__"